import { FC } from "react";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../../layouts";
import { YearList } from "../../../components/Year";

export interface ITaxYearListPage {}

export const TaxYearListPage: FC<ITaxYearListPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Years"
			pageTitleIcon={<DescriptionOutlinedIcon />}
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[{ text: "Years", navigateTo: "/years/list" }]}
			mainContents={<YearList />}
		/>
	);
};
